import { request } from '../utils/httpClient';

export const createMessage = (data) => {
  return request({
    url: `/messages/create`,
    method: 'POST',
    data: data,
  });
};

export const updateMessage = (data) => {
  return request({
    url: `/messages/${data.id}`,
    method: 'PATCH',
    data: data,
  });
};

export const getLocalChapterResources = (data) => {
  return request({
    url: `/resources/local_chapter/${data.chapterId}`,
    method: 'GET',
  });
};

export const getSPDResources = (data) => {
  return request({
    url: `/resources/spd_chapter/${data.chapterId}`,
    method: 'GET',
  });
};
